import request from '@/utils/request'
import { ADMIN_URL } from '@/utils/constant'
export function getAgreementList(currentPage, pageSize, params) {
  return request({
    url: `${ADMIN_URL}/getagreementlist`,
    method: 'post',
    params: {
      page: currentPage,
      limit: pageSize,
      ...params
    }
  })
}

export function addOrUpdateAgreement(data) {
  const action = data.id ? 'updateagreement' : 'addagreement'
  return request({
    url: `${ADMIN_URL}/${action}`,
    method: 'post',
    data
  })
}

export function viewAgreement(params) {
  return request({
    url: `${ADMIN_URL}/getagreementinfo`,
    method: 'get',
    params
  })
}

export function delAgreement(data) {
  return request({
    url: `${ADMIN_URL}/delagreement`,
    method: 'post',
    params: data
  })
}

export function getFaqList(currentPage, pageSize, params) {
  return request({
    url: `${ADMIN_URL}/getfaqlist`,
    method: 'post',
    params: {
      page: currentPage,
      limit: pageSize,
      ...params
    }
  })
}

export function getFaqInfo(params) {
  return request({
    url: `${ADMIN_URL}/getfaqinfo`,
    method: 'get',
    params
  })
}

export function addOrUpdateFaq(data) {
  const action = data.id ? 'updatefaq' : 'addfaq'
  return request({
    url: `${ADMIN_URL}/${action}`,
    method: 'post',
    params: data
  })
}

export function delFaq(data) {
  return request({
    url: `${ADMIN_URL}/delfaq`,
    method: 'post',
    params: data
  })
}

export function getBannerList(currentPage, pageSize, params) {
  return request({
    url: `${ADMIN_URL}/getadvertlist`,
    method: 'get',
    params: {
      page: currentPage,
      limit: pageSize,
      ...params
    }
  })
}

export function getBannerInfo(params) {
  return request({
    url: `${ADMIN_URL}/getadvertinfo`,
    method: 'get',
    params
  })
}

export function addOrUpdateBanner(data) {
  const action = data.id ? 'updateadvert' : 'addadvert'
  return request({
    url: `${ADMIN_URL}/${action}`,
    method: 'post',
    params: data
  })
}

export function delBanner(data) {
  return request({
    url: `${ADMIN_URL}/deladvert`,
    method: 'post',
    params: data
  })
}

export function getFeedbackList(currentPage, pageSize, params) {
  return request({
    url: `${ADMIN_URL}/getfeedbacklist`,
    method: 'post',
    params: {
      page: currentPage,
      limit: pageSize,
      ...params
    }
  })
}

export function handleFeedback(data) {
  return request({
    url: `${ADMIN_URL}/handlefeedback`,
    method: 'post',
    params: data
  })
}

export function getQuestionList(currentPage, pageSize, params) {
  return request({
    url: `${ADMIN_URL}/getquestionlist`,
    method: 'get',
    params: {
      page: currentPage,
      limit: pageSize,
      ...params
    }
  })
}

export function getPoster(params) {
  return request({
    url: `${ADMIN_URL}/getposter`,
    method: 'get',
    params
  })
}

export function setPoster(data) {
  return request({
    url: `${ADMIN_URL}/setposter`,
    method: 'post',
    params: data
  })
}
